import { IconProps } from './type';
import betaFlag from 'assets/images/beta.png';

const BetaFlag = (props: IconProps) => {
  return <img width={40} src={betaFlag} alt="Beta" />;
};

export default BetaFlag;
